// extracted by mini-css-extract-plugin
export default {"infoBoxContainer":"_3RLV8RwL2yTSGbH2lLJm4w"};